import {
  ControlsStrategyTypes,
  DefaultControlsStrategy
} from './default-controls-strategy';
import { ControlsStrategyType } from './default-controls-strategy';

export class EndScreenCTAControlsStrategy extends DefaultControlsStrategy {
  type: ControlsStrategyType = ControlsStrategyTypes.END_SCREEN_CTA;

  canExpand(): boolean {
    return false;
  }

  shouldDisplayProgressBar(): boolean {
    return false;
  }

  shouldDisplayVastIcon(): boolean {
    return false;
  }

  shouldHideOptout(): boolean {
    return false;
  }

  shouldDisplayOptOut(): boolean {
    return true;
  }
}
